export default "__VITE_ASSET__C2m_nZ$t__"